import api from "../Api";
import routes from "../constants/ApiRoutesConstants";

export default async function PatchUserDetailsUpdate(formData) {
  const jsonData = Object.fromEntries(formData.entries());

  const res = await api.patch(routes.PATCH_USER_DETAILS, jsonData);

  return res;
}
